import { render, staticRenderFns } from "./BeefPolicyTypeModal.Style#Drawer.vue?vue&type=template&id=671d0db6&scoped=true"
import script from "./BeefPolicyTypeModal.Style#Drawer.vue?vue&type=script&lang=js"
export * from "./BeefPolicyTypeModal.Style#Drawer.vue?vue&type=script&lang=js"
import style0 from "./BeefPolicyTypeModal.Style#Drawer.vue?vue&type=style&index=0&id=671d0db6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671d0db6",
  null
  
)

export default component.exports